var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"error-page.content"},[_c('h1',[_vm._v("Oops!")]),_c('h2',[_vm._v("404 Error")]),_c('div',[_vm._v(" 对不起, 您请求的界面不存在! ")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v(" 返回 首页 ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }